import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext'; 
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Import Font Awesome CSS first
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import centralized font management
import './styles/fonts.css';

// Add Font Awesome CSS rule to fix icon display
const fontAwesomeStyle = document.createElement('style');
fontAwesomeStyle.textContent = `
  .fas, .far, .fab { 
    font-family: 'Font Awesome 6 Free', 'Font Awesome 6 Brands', 'Font Awesome 5 Free', 'Font Awesome 5 Brands', 'FontAwesome', sans-serif; 
  }
`;
document.head.appendChild(fontAwesomeStyle);

// Error handling
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Safe mounting
function mountApp() {
  const container = document.getElementById('root');
  
  if (!container) {
    console.error('Root element not found');
    return;
  }

  try {
    const root = createRoot(container);
    
    root.render(
      <React.StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </React.StrictMode>
    );

    console.log('✅ PT Thai Plus app mounted successfully');
    console.log('✅ React root container created');
    
    // Force hide loading screen after mount
    setTimeout(() => {
      const loadingScreen = document.getElementById('loading-screen');
      if (loadingScreen) {
        console.log('✅ Hiding loading screen after React mount');
        loadingScreen.style.opacity = '0';
        loadingScreen.style.transition = 'opacity 0.5s ease-out';
        setTimeout(() => {
          loadingScreen.style.display = 'none';
        }, 500);
      }
    }, 100);

  } catch (error) {
    console.error('❌ Failed to mount React app:', error);
    
    // Fallback content
    container.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 20px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
        background: linear-gradient(135deg, #232956 0%, #df2528 100%);
        color: white;
        text-align: center;
      ">
        <div style="
          background: rgba(255, 255, 255, 0.1);
          padding: 40px;
          border-radius: 20px;
          backdrop-filter: blur(10px);
          max-width: 500px;
        ">
          <h1 style="margin-bottom: 20px; font-size: 3rem;">🏋️‍♂️</h1>
          <h2 style="margin-bottom: 20px;">PT Thai Plus</h2>
          <p style="margin-bottom: 30px; opacity: 0.9;">
            ขออภัย เกิดข้อผิดพลาดในการโหลดแอปพลิเคชัน
          </p>
          <button 
            onclick="window.location.reload()" 
            style="
              background: white;
              color: #232956;
              border: none;
              padding: 15px 30px;
              border-radius: 10px;
              font-weight: bold;
              cursor: pointer;
              font-size: 16px;
            "
          >
            🔄 โหลดหน้าใหม่
          </button>
        </div>
      </div>
    `;
  }
}

// Mount when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mountApp();
    serviceWorkerRegistration.register();
  });
} else {
  mountApp();
  serviceWorkerRegistration.register();
}

export default mountApp;